import { render, staticRenderFns } from "./FacialRecognitionInstructions.vue?vue&type=template&id=03dd96b0&"
import script from "./FacialRecognitionInstructions.vue?vue&type=script&lang=js&"
export * from "./FacialRecognitionInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports